import { AppLanguageDto } from '@/api/generated';
import { useApiClient } from '@/api/util/useApiClient.util.ts';
import i18n, { type AppLanguage, getAppLanguage } from '@/i18n.ts';
import { useUserContext } from '@/utils/providers/userContext/useUserContext.tsx';
import { useEffect } from 'react';

const APP_LANGUAGE_DTO: Record<AppLanguage, AppLanguageDto> = {
  en: AppLanguageDto.English,
  fr: AppLanguageDto.French,
  pl: AppLanguageDto.Polish,
};

// Emails sent outside a request (e.g. quiz feedback) use the language stored on the user.
// Nobody logged in: nothing to save, the backend stores the language of the login request instead
export const usePersistPreferredLanguage = (): void => {
  const { restUserApi } = useApiClient();
  const { user } = useUserContext();
  const userId = user?.userId;

  useEffect(() => {
    if (!userId) {
      return;
    }
    const persistPreferredLanguage = () => {
      restUserApi
        .setUserPreferredLanguage(userId, { language: APP_LANGUAGE_DTO[getAppLanguage()] })
        .catch(error => console.warn('Saving preferred language failed:', error));
    };

    i18n.on('languageChanged', persistPreferredLanguage);
    return () => i18n.off('languageChanged', persistPreferredLanguage);
  }, [restUserApi, userId]);
};
